import apiClient from './client';

/**
 * POST /api/analysis/standard
 * Single-shot analysis — returns report_markdown directly.
 * @param {string} caseNumber
 * @param {string} [documentContent] - Optional pinned/analyst document text
 */
export const runStandardAnalysis = async (caseNumber, documentContent) => {
  const { data } = await apiClient.post('/api/analysis/standard', {
    case_number: caseNumber,
    ...(documentContent ? { document_content: documentContent } : {}),
  });
  return data; // { case_number, report_markdown }
};

/**
 * POST /api/analysis/agentic
 * Multi-agent analysis (RF01 + RF02 + RF03 specialists → master synthesiser).
 * Returns when all agents have completed.
 * @param {string} caseNumber
 */
export const runAgenticAnalysis = async (caseNumber) => {
  const { data } = await apiClient.post('/api/analysis/agentic', {
    case_number: caseNumber,
  });
  return data; // AgenticAnalysisResponse: { rf01, rf02, rf03, master, structured_report }
};
